import { render, staticRenderFns } from "./PerCaseMetrics.vue?vue&type=template&id=1923436d&scoped=true&"
import script from "./PerCaseMetrics.vue?vue&type=script&lang=js&"
export * from "./PerCaseMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1923436d",
  null
  
)

export default component.exports